// 数据看板-标题栏
<template>
  <div class="DkbBar">
    <!-- 标题栏 -->
    <div class="titleBar">
      <div class="logoArea">
        <img class="logo" :src="logo_url" alt="">
        <p class="text">{{company_name}}</p>
      </div>
      <div class="titleArea">
        <h2 class="title">数据控制中心</h2>
      </div>
      <div :class="['btnArea', {showGuide: isShowGuide}]">
        <div :class="['dbtn', {'guideActive': guideActive === 1}]" @click="showDialog('DeviceCenter', '设备中心')">设备中心
        </div>
        <div class="dbtn hasSub">更多
          <ul :class="['subList', {'overflow': !isShowGuide || guideActive === 1 } , {'showSubList': guideActive > 1}]">
            <li :class="['li', {'guideActive': guideActive === 2}]" @click="showDialog('UserManage', '用户管理')">用户管理</li>
            <li :class="['li', {'guideActive': guideActive === 3}]" @click="showDialog('AuthorizationManage', '授权管理')">
              授权管理</li>
            <li :class="['li', {'guideActive': guideActive === 4}]" @click="handleCommand('moreSetting')">更多设置</li>
          </ul>
        </div>
        <div class="dbtn" @click="isShowGuide = true">帮助</div>
        <div class="dbtn login hasSub">
          <span class="text one-line-overhidden">{{user_name}}</span>
          <ul :class="['subList overflow']">
            <li class="li" @click="handleCommand('modifyPassword')">修改密码</li>
            <li class="li" @click="handleCommand('loginSetting')">基本设置</li>
            <li class="li" @click="handleCommand('loginOut')">退出登录</li>
          </ul>
        </div>
        <!-- 引导内容 -->
        <div class="guideArea" v-if="isShowGuide">
          <div class="guideBox">
            <p class="text">{{guideInfo[guideActive-1]}}</p>
            <p class="btn" @click="clickGuide">{{guideActive === 4 ? '确定' : '下一步'}}</p>
            <span class="btn-close"></span>
            <div class="step">
              <span :class="['item', {'active': guideActive === index+1}]" v-for="(item, index) in 4" :key="index">
                {{guideActive === index+1 ? guideActive: ''}}
              </span>
            </div>
            <span :class="['arrow', 'arrow'+guideActive]"></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 对话框 -->
    <el-dialog class="DkbDialog" :title="outerTitle" :visible.sync="outerVisible">
      <UserManage v-if="outerType === 'UserManage'" />
      <AuthorizationManage v-if="outerType === 'AuthorizationManage'" />
      <DeviceCenter v-if="outerType === 'DeviceCenter'" />
    </el-dialog>
  </div>
</template>

<script>
import UserManage from '@/components/DkbPage/DialogPage/UserManage/UserManage'        // 组织管理
import AuthorizationManage from '@/components/DkbPage/DialogPage/AuthorizationManage/AuthorizationManage'        // 授权管理
import DeviceCenter from '@/components/DkbPage/DialogPage/DeviceCenter/DeviceCenter'        // 设备中心
import { dkbApi } from "../../../../static/js/dkb/dkb.js"
import { localUserInfo, setLogoTitle, updataBreadCrumb, showToast } from "../../../../static/js/utility/utility.js"
let vm

export default {
  name: 'DkbBar',
  components: {
    UserManage,
    AuthorizationManage,
    DeviceCenter
  },
  data () {
    return {
      logo_url: '',
      company_name: '',
      user_name: '',
      isShowGuide: false, // 是否显示引导内容
      guideActive: 1,  // 当前引导内容第几步
      guideInfo: [
        '点击“设备中心”，可查看设备状态控制设备开关。',
        '点击“用户管理”可添加、修改企业员工信息。',
        '点击“授权管理”,可对企业员工进行设别管理分配。',
        '点击“更多设置”,进行其他模块功能配置。',
      ],
      Info: {},

      outerType: '',
      outerTitle: '',
      outerVisible: false
    }
  },
  created () {
    vm = this
    vm.logo_url = localUserInfo.getItem().logo_url ? localUserInfo.getItem().logo_url : ('../../../../' + this.$store.state.currentServerInfo.logoUrl)
    vm.company_name = localUserInfo.getItem().company_name
    vm.user_name = localUserInfo.getItem().user_name
    // vm.getAccountInfo()
  },
  mounted () {
    // console.log('route', this.$route)
  },
  computed: {
  },
  methods: {
    // 操作弹窗
    showDialog (type, title) {
      vm.outerType = type
      vm.outerTitle = title
      vm.outerVisible = true
    },
    // 点击账号下拉菜单list，点击执行相关操作
    handleCommand (command) {
      // console.log('command', command)
      // 退出登录
      if (command === 'loginOut') {
        // 清空缓存数据,跳转登录页
        localStorage.clear()
        sessionStorage.clear()
        setLogoTitle()
        this.$router.push({
          path: '/'
        })
      } else if (command === 'loginSetting') {
        let navBarActive = [{ function_tab: 'LoginSetting', function_name: '基本设置' }]
        // 更新面包屑内容
        updataBreadCrumb(2, navBarActive)
        // 基本设置
        this.$router.push({
          path: '/CLoginSetting'
        })
      } else if (command === 'modifyPassword') {
        let navBarActive = [{ function_tab: 'ModifyPassword', function_name: '修改密码' }]
        // 更新面包屑内容
        updataBreadCrumb(2, navBarActive)
        // 修改密码
        this.$router.push({
          path: '/CModifyPassword'
        })
      } else if (command === 'moreSetting') {
        let navBarActive = [{}]
        // 更新面包屑内容
        updataBreadCrumb(2, navBarActive)
        // 修改密码
        this.$router.push({
          path: '/CIndex'
        })
      }
    },
    // 点击指引
    clickGuide () {
      if (vm.guideActive === 4) {
        vm.isShowGuide = false
        vm.guideActive = 1
      } else {
        vm.guideActive += 1
      }
    },
    // 获取账号信息
    async getAccountInfo () {
      let res = await dkbApi.getAccountInfo()
      console.log('res', res)
      if (res.ErrCode === 0) {
        vm.Info = res.Result
      } else {
        showToast(res.ErrMsg)
      }

    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
.DkbBar {
  .titleBar {
    width: 100%;
    height: inherit;
    background: url("/static/images/dkb/title_bg.png") center no-repeat;
    background-size: 17.35rem 1.13rem;
    display: flex;
    .logoArea {
      flex-shrink: 0;
      width: 6.6rem;
      margin-top: 0.16rem;
      display: flex;
      // align-items: center;
      .logo {
        flex-shrink: 0;
        // width: 0.52rem;
        height: 0.53rem;
        margin: 0 0.26rem 0 0.46rem;
      }
      .text {
        font-size: 0.26rem;
        line-height: 0.53rem;
        letter-spacing: 0.03rem;
      }
    }
    .titleArea {
      flex-shrink: 0;
      width: 5.27rem;
      .title {
        margin-top: 0.1rem;
        font-size: 0.4rem;
        font-weight: bold;
        letter-spacing: 0.16rem;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        background: linear-gradient(
          0deg,
          rgba(81, 193, 225, 1) 0%,
          rgba(255, 255, 255, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .btnArea {
      flex-shrink: 0;
      width: 6.58rem;
      height: 0.37rem;
      margin-top: 0.24rem;
      background: url("/static/images/dkb/dbtn_bg.png") right no-repeat;
      background-size: 5.57rem 0.37rem;
      display: flex;
      justify-content: flex-end;
      .dbtn {
        text-align: center;
        height: 0.37rem;
        line-height: 0.37rem;
        font-size: 0.2rem;
        letter-spacing: 0.02rem;
        &:nth-child(1) {
          width: 0.94rem;
        }
        &:nth-child(2),
        &:nth-child(3) {
          width: 0.61rem;
          margin-left: 0.48rem;
          letter-spacing: 0.1rem;
        }
        &:nth-child(4) {
          width: 1.52rem;
          margin: 0 0.13rem 0 0.48rem;
          background: url("/static/images/dkb/user_t.png") 0.09rem center
            no-repeat;
          background-size: 0.28rem 0.28rem;
        }
        &.hasSub {
          position: relative;
          .subList {
            height: 0;
            width: 0.9rem;
            background-color: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0.37rem;
            left: -0.29rem;
            z-index: 1000;
            transition: all 0.5s ease;
            &.overflow {
              overflow: hidden;
            }
            .li {
              width: 100%;
              height: 0.4rem;
              line-height: 0.4rem;
              font-size: 0.16rem;
              letter-spacing: 0;
              &:hover {
                color: #7298bf;
              }
            }
          }
          &:hover .subList {
            height: 1.2rem;
            // display: block;
          }
        }
        &.login {
          .text {
            width: 100%;
            height: inherit;
            line-height: inherit;
            text-align: left;
            padding-left: 0.5rem;
          }
          .subList {
            width: 1.8rem;
          }
        }
      }
      // 引导内容-当前引导内容
      &.showGuide {
        .hasSub .subList.showSubList {
          height: 1.2rem;
          // 用户管理，授权管理，更多设置
          .li.guideActive::before,
          .li.guideActive::after {
            content: "";
            width: 1.08rem;
            height: 0.48rem;
            left: -0.1rem;
            top: -0.02rem;
          }
        }
        .guideActive {
          position: relative;
        }
        .guideActive::before {
          box-shadow: 0 0 0 1000vh rgba(0, 0, 0, 0.5);
        }
        .guideActive::after {
          box-sizing: border-box;
          border: 0.02rem dashed #ffffff;
          box-shadow: 0 0 0.06rem rgba(255, 255, 255, 0.43),
            0 0 0.06rem rgba(255, 255, 255, 0.43) inset;
        }
        .guideActive::before,
        .guideActive::after {
          position: absolute;
          z-index: 20;
        }
        // 设备中心
        .dbtn:nth-child(1).guideActive::before,
        .dbtn:nth-child(1).guideActive::after {
          content: "";
          width: 1.58rem;
          height: 0.48rem;
          left: -0.35rem;
          top: -0.05rem;
        }
      }
    }
  }
}
// 引导内容区
.guideArea {
  // display: none;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  .guideBox {
    width: 4.04rem;
    height: 1.94rem;
    padding: 0 0.42rem;
    border-radius: 0.05rem;
    background-color: #ffffff;
    text-align: center;
    position: absolute;
    right: 2.56rem;
    top: 2.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .text {
      color: #122a4e;
      letter-spacing: 0.02rem;
      font-size: 0.2rem;
      line-height: 0.3rem;
    }
    .btn {
      width: 1.68rem;
      height: 0.52rem;
      line-height: 0.52rem;
      margin-top: 0.16rem;
      color: #ffffff;
      background-color: #122b50;
      border-radius: 0.1rem;
    }
    // 关闭
    .btn-close {
      width: 0.28rem;
      height: 0.29rem;
      background: url(/static/images/dkb/dbtn_close.png) center no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: -0.31rem;
      top: -0.28rem;
    }
    // 步骤条
    .step {
      position: absolute;
      bottom: -0.46rem;
      display: flex;
      align-items: center;
      .item {
        display: block;
        width: 0.14rem;
        height: 0.14rem;
        border-radius: 50%;
        background-color: #879098;
        & + .item {
          margin-left: 0.15rem;
        }
        &.active {
          width: 0.27rem;
          height: 0.27rem;
          line-height: 0.27rem;
          color: #202f47;
          background-color: #ffffff;
        }
      }
    }
    // 箭头
    .arrow {
      position: absolute;
      &.arrow1 {
        width: 0.76rem;
        height: 1.43rem;
        top: -1.71rem;
        left: 0.74rem;
        background: url(/static/images/dkb/guide/arrow_1.png) center no-repeat;
        background-size: 100% 100%;
      }
      &.arrow2 {
        width: 1.15rem;
        height: 1.24rem;
        top: -1.4rem;
        left: 1.38rem;
        background: url(/static/images/dkb/guide/arrow_2.png) center no-repeat;
        background-size: 100% 100%;
      }
      &.arrow3 {
        width: 1.04rem;
        height: 1rem;
        top: -1.15rem;
        left: 1.6rem;
        background: url(/static/images/dkb/guide/arrow_3.png) center no-repeat;
        background-size: 100% 100%;
      }
      &.arrow4 {
        width: 0.65rem;
        height: 0.78rem;
        top: -0.92rem;
        left: 1.9rem;
        background: url(/static/images/dkb/guide/arrow_4.png) center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
// 一级弹窗
.DkbDialog > .el-dialog {
  width: 11.22rem;
  padding-bottom: 0.36rem;
  border-radius: 0.1rem;
  background-color: #214379;
  .el-dialog__header {
    height: 0.7rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    .el-dialog__title {
      font-size: 0.18rem;
      color: #ffffff;
    }
    .el-icon {
      font-size: 0.22rem;
      color: #ffffff;
    }
  }
  .el-dialog__body {
    padding: 0.25rem 0.35rem 0.3rem;
    background-color: #072b4c;
  }

  .btn-search {
    display: block;
    height: 0.36rem;
    line-height: 0.36rem;
    padding: 0 0.1rem;
    border-radius: 0.04rem;
    color: #ffffff;
    background-color: #1993d9;
  }
}
// 二级弹窗
.DkbInnerDialog > .el-dialog {
  width: 5.74rem;
  border-radius: 0.1rem;
  background-color: #18376a;
  .el-dialog__header {
    height: 0.6rem;
    line-height: 0.6rem;
    padding: 0 0.2rem;
    background-color: #214379;
    border-top-left-radius: 0.1rem;
    border-top-right-radius: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .el-dialog__title {
      font-size: 0.18rem;
      color: #ffffff;
    }
    .el-icon {
      font-size: 0.22rem;
      color: #ffffff;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
  .el-dialog__body {
    padding: 0.3rem;
  }
}
.DkbDialog > .el-dialog,
.DkbInnerDialog > .el-dialog {
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    .btn {
      display: block;
      padding: 0;
      width: 0.78rem;
      height: 0.37rem;
      line-height: 0.35rem;
      font-size: 0.14rem;
      text-align: center;
      border-radius: 0.04rem;
      border: 0.01rem solid #7ca8cf;
    }
    .btn + .btn {
      margin-left: 0.3rem;
    }
    .btn-confirm {
      color: #072c4e;
      background-color: #ffffff;
    }
    .btn-cancel {
      color: #ffffff;
      background-color: #26467d;
    }
  }
  // 弹窗公用表单样式
  .innerForm {
    padding-top: 0.16rem;
    color: #ffffff;
    &.el-form {
      .el-form-item {
        display: flex;
        align-items: center;
        .el-form-item__label {
          flex-shrink: 0;
          color: #ffffff;
          font-size: 0.16rem;
        }
        .el-form-item__content {
          width: 100%;
          margin-left: 0 !important;
        }
        .inputBox {
          width: 100%;
          height: 0.4rem;
          input {
            border: none;
            background-color: #2d5391;
            color: #ffffff;
          }
          input::placeholder {
            color: #a6aeb8;
          }
        }
      }
    }
  }
}

.el-pagination.dkbPagination {
  color: #b2b2b2;
  display: flex;
  align-items: center;
  justify-content: center;
  button:disabled,
  .el-pager li,
  .btn-next,
  .btn-prev {
    background-color: transparent;
  }
  .btn-next,
  .btn-prev {
    height: 0.22rem;
    line-height: 0.22rem;
    color: #b2b2b2;
    .el-icon {
      font-size: 0.22rem;
    }
  }
  .el-pager li.active {
    // color: #ffffff;
  }
  .el-pager li {
    font-size: 0.16rem;
    height: 0.22rem;
    line-height: 0.22rem;
  }
  .el-pager li.more {
    color: #b2b2b2;
  }
  .el-pagination__jump {
    color: #ffffff;
    font-size: 0.16rem;
    height: 0.22rem;
    line-height: 0.22rem;
    .el-input {
      position: relative;
      top: -0.02rem;
      input {
        width: 0.3rem;
        height: 0.2rem;
        box-sizing: border-box;
        border-radius: 0.02rem;
        border: 0.01rem solid #ffffff;
        background-color: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/Layout/DkbBar.vue